import angular, { ILogService, ITimeoutService } from 'angular'
import { clone } from 'lodash'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { MainQuestionEdit } from 'src/_candidato/data/main-question'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IModelMainQuestion, IPregConParentProjection, ISeleccionForm } from 'src/model/candidato-api'

class TarjetaMainQuestionComponentCtrl {
  mainQuestion!: MainQuestionEdit

  editando: boolean = false

  form = {
    data: null as null | IModelMainQuestion,
  }

  dirty = false

  usosData = {
    visible: false,
    leido: false,
    list: [] as UsosPreg[],
  }

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[TarjetaMainQuestionComponentCtrl] onInit')

    this.form.data = clone(this.mainQuestion.data.mq)
    this.editando = this.mainQuestion.nuevoreg
  }

  editarMainQ() {
    this.editando = !this.editando
    this.$timeout(() => (this.$element.find('select') as any).formSelect(), 1)
    this.$timeout(() => {
      let textarea = this.$element.find('.materialize-textarea')

      if (textarea && textarea[0]) M.textareaAutoResize(textarea)
    }, 200)
  }

  guardarMainQ() {
    const call = this.mainQuestion.nuevoreg
      ? () =>
          this.AccesoDatos.MainQuestions_CLIENT.altaPregPrincipal({
            mq: this.form.data,
          })
      : () =>
          this.AccesoDatos.MainQuestions_CLIENT.editarPregPrincipal(this.mainQuestion.data.mq.idmainq, {
            mq: this.form.data,
          })

    call().then((response) => {
      this.mainQuestion.update(response)
      this.form.data = clone(response.mq)

      this.dirty = false
    })
  }

  refreshMainQ() {
    if (this.mainQuestion.nuevoreg) {
      return
    }

    this.AccesoDatos.MainQuestions_CLIENT.leerPregPrincipal(this.mainQuestion.data.mq.idmainq) //
      .then((response) => {
        this.mainQuestion.update(response)
        this.form.data = clone(response.mq)

        this.dirty = false
      })
  }

  cerrarUsosMainQ() {
    this.usosData.visible = false
  }

  usosMainQ() {
    this.AccesoDatos.MainQuestions_CLIENT.usosPregPrincipal(this.mainQuestion.data.mq.idmainq) //
      .then((list) => {
        this.usosData = {
          visible: true,
          leido: true,
          list: list.map((l) => new UsosPreg(l)),
        }
      })
  }

  cerrarUsosPreg(preg: UsosPreg) {
    preg.usosData.visible = false
  }

  usosPregEnForms(preg: UsosPreg) {
    const pregForm = preg.data.parent || preg.data.preg

    this.AccesoDatos.Preg_CLIENT.usosPregunta(pregForm.idquest).then((list) => {
      preg.usosData = {
        visible: true,
        leido: true,
        list,
      }
    })
  }
}

class UsosPreg {
  usosData = {
    visible: false,
    leido: false,
    list: [] as ISeleccionForm[],
  }

  constructor(public data: IPregConParentProjection) {}
}

angular.module('candidato').component('tarjetaMainQuestion', {
  bindings: {
    mainQuestion: '<',
  },
  controller: TarjetaMainQuestionComponentCtrl,
  // templateUrl: "tarjeta-main-question.component.html",
  template: require('./tarjeta-main-question.component.html'),
})
